import './index.scss'
$(".faq-list li").click(function() {
    $(this).find(".text").slideToggle();
    $(this).toggleClass("active");
})